import React, { useState } from "react";
import LoginForm from "./LoginForm";

const SignupModal: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center p-5">
        <LoginForm />
    </div>
  );
};

export default SignupModal;
